import './growth.css';
export default function LearningPath({ navigate, lang, t }) {
  return (
    <section className="hp-section">
      <div className="hp-section-heading">
        <div>
          <h2 className="hp-section-title">{t('home.growthPathTitle')}</h2>
          <p className="hp-section-desc" style={{ marginBottom: 0 }}>{t('home.growthPathDesc')}</p>
        </div>
        <button className="hp-section-more" onClick={() => navigate('/docs')}>
          {lang === 'zh' ? '从第一步开始 →' : 'Start from step 1 →'}
        </button>
      </div>
      <div className="hp-path-grid">
        <div className="hp-path-card" onClick={() => navigate('/docs')}>
          <div className="hp-path-card-head">
            <span className="hp-path-step">01 {lang === 'zh' ? '认知入门' : 'Cognition'}</span>
            <span className="hp-path-tag hp-path-tag-free">{lang === 'zh' ? '免费' : 'Free'}</span>
          </div>
          <div className="hp-path-card-desc">{lang === 'zh' ? '阅读基础文章，了解财富思维和加密货币核心概念' : 'Read foundational articles on wealth mindset and crypto basics'}</div>
          <div className="hp-path-card-link">{lang === 'zh' ? '阅读基础文章 →' : 'Read articles →'}</div>
        </div>
        <div className="hp-path-card" onClick={() => navigate('/docs')}>
          <div className="hp-path-card-head">
            <span className="hp-path-step">02 {lang === 'zh' ? '系统阅读' : 'Reading'}</span>
            <span className="hp-path-tag hp-path-tag-book">{lang === 'zh' ? '书单' : 'Books'}</span>
          </div>
          <div className="hp-path-card-desc">{lang === 'zh' ? '精选投资经典书籍，构建完整的知识体系' : 'Curated investment classics to build your knowledge system'}</div>
          <div className="hp-path-card-link">{lang === 'zh' ? '进入入门书单 →' : 'View book list →'}</div>
        </div>
        <div className="hp-path-card" onClick={() => navigate('/docs')}>
          <div className="hp-path-card-head">
            <span className="hp-path-step">03 {lang === 'zh' ? '观点校准' : 'Perspectives'}</span>
            <span className="hp-path-tag hp-path-tag-opinion">{lang === 'zh' ? '观点' : 'Views'}</span>
          </div>
          <div className="hp-path-card-desc">{lang === 'zh' ? '聆听投资大师智慧，建立正确的交易思维' : 'Learn from master investors, build the right trading mindset'}</div>
          <div className="hp-path-card-link">{lang === 'zh' ? '看名人观点 →' : 'View quotes →'}</div>
        </div>
        <div className="hp-path-card" onClick={() => navigate('/register')}>
          <div className="hp-path-card-head">
            <span className="hp-path-step">04 {lang === 'zh' ? '准备进阶' : 'Level Up'}</span>
            <span className="hp-path-tag hp-path-tag-register">{lang === 'zh' ? '注册' : 'Sign Up'}</span>
          </div>
          <div className="hp-path-card-desc">{lang === 'zh' ? '注册并了解专业版工具，开启实战之旅' : 'Register to explore pro tools and start trading for real'}</div>
          <div className="hp-path-card-link">{lang === 'zh' ? '注册并了解专业版 →' : 'Register & explore Pro →'}</div>
        </div>
      </div>
    </section>
  );
}
